import { denormalize } from "normalizr";
import { agentSchema } from "./agent-schema";
export const GET_AGENT = "GET_AGENT";
export const AGENTS = "agents";
const getters = {
  [AGENTS]: state => {
    const {
      allIds,
      byId
    } = state.agents;
    return denormalize(allIds, [agentSchema], {
      agents: byId
    });
  },
  [GET_AGENT]: state => agentUsername => {
    return state.agents.byId[agentUsername];
  }
};
export default getters;